import React from "react"
import Layout from "../components/layout"
import { StaticImage } from "gatsby-plugin-image"
import { Row, Col, Button } from "react-bootstrap"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faFileDownload } from "@fortawesome/free-solid-svg-icons"
import "../utils/font-awesome"
import Dropdown from 'react-bootstrap/Dropdown';

// import ScrollToTop from "react-scroll-to-top"
// import { Helmet } from "react-helmet"
import Seo from "../components/seo"

import {
  // withPrefix,
  Link,
} from "gatsby"
// import { faMapPin } from "@fortawesome/free-solid-svg-icons"

const image = {
  src: "/frontcover.jpg",
  height: 300,
  width: 400,
}

const IndexPage = () => (
  <Layout>
    <Seo
      title="AR6 Synthesis Report: Climate Change 2023"
      description="Intergovernmental Panel on Climate Change"
      image={image}
      href="https://ipcc.ch/report/ar6/syr"
    />
    <header>
      <div className="header__main h-home">
        <div className="artistLink">
          <Link to="resources/credits" className="light">
            Artwork credits
          </Link>
        </div>
        <div className="home-title">
          <h2>AR6 Synthesis Report</h2>
          <h1 className="fw-bold">Climate Change 2023</h1>
        </div>
        <div className="home-overlay"></div>
      </div>
    </header>
    <div className="home-container">
      <section className="home-boxes">
        {/* <p class="disclaimer">The approved Summary for Policymakers and adopted Longer Report remain subject to  final copy editing and layout.</p> */}
        <Link to="https://www.ipcc.ch/report/ar6/syr/downloads/report/IPCC_AR6_SYR_SPM.pdf" target="_blank">
          <div className="hx">Summary for<br />Policymakers <span className="home-arrow">▼</span></div>
        </Link>
        <Link to="https://www.ipcc.ch/report/ar6/syr/downloads/report/IPCC_AR6_SYR_LongerReport.pdf" target="_blank">
          <div>Longer Report <span className="home-arrow">▼</span></div>
        </Link>
        <Link to="https://www.ipcc.ch/report/ar6/syr/downloads/report/IPCC_AR6_SYR_FullVolume.pdf" target="_blank">
          <div>SYR (Full volume)<span className="home-arrow">▼</span></div>
        </Link>
        <Link to="/figures">
          <div>Figures <span className="home-arrow">►</span></div>
        </Link>
        <Link to="/resources/spm-headline-statements">
          <div className="hx">Headline<br />Statements <span className="home-arrow">▼</span></div>
        </Link>
        <Link to="https://www.ipcc.ch/report/ar6/syr/downloads/report/IPCC_AR6_SYR_AnnexesIndex.pdf" target="_blank">
          <div className="hx">Annexes<br />and Index <span className="home-arrow">▼</span></div>
        </Link>
        <Link to="/resources/press">
          <div>Press Release <span className="home-arrow">►</span></div>
        </Link>
        <Link to="https://www.ipcc.ch/report/ar6/syr/downloads/press/IPCC_AR6_SYR_SlideDeck.pdf" target="_blank">
          <div>Presentation <span className="home-arrow">▼</span></div>
        </Link>
      </section>
      <div className="home-video">
        <iframe width="560" height="315" src="https://www.youtube.com/embed/T9CeECpxtx8" className="home-video-embed" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
      </div>
      <div className="home-videodrop">
        <Dropdown>
          <Dropdown.Toggle variant="success" id="dropdown-basic" className="btn-ipcc btn btn-primary dl-dropdown syr-home">
            Watch video in other UN languages
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <Dropdown.Item target={"_blank"} href="https://youtu.be/U9m07uKOwnU">Arabic</Dropdown.Item>
            <Dropdown.Item target={"_blank"} href="https://youtu.be/PsrZzdx3XAg">Chinese</Dropdown.Item>
            <Dropdown.Item target={"_blank"} href="https://youtu.be/cEcgpbKoCbU">French</Dropdown.Item>
            <Dropdown.Item target={"_blank"} href="https://youtu.be/t7BGC6TmtCE">Russian</Dropdown.Item>
            <Dropdown.Item target={"_blank"} href="https://youtu.be/H5aDfE8_X-Q">Spanish</Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>
    </div>
  </Layout>
)

export default IndexPage
